import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import { kaapiClustersSelector } from 'k8s/components/kaapi/clusters/selectors'
import DataKeys from 'k8s/DataKeys'
import { findClusterName } from 'k8s/util/helpers'

export const rolesSelector = createSharedSelector(
  getDataSelector<DataKeys.KubeRoles>(DataKeys.KubeRoles),
  kaapiClustersSelector,
  (items, clusters) => {
    return items.map((item) => ({
      ...item,
      id: item?.metadata?.uid,
      name: item?.metadata?.name,
      namespace: item?.metadata?.namespace,
      clusterName: findClusterName(clusters, item.clusterId),
      created: item?.metadata?.creationTimestamp,
      pickerLabel: `Role: ${item?.metadata?.name}`,
      pickerValue: `Role:${item?.metadata?.name}`,
    }))
  },
)
